<template>
  <div class="mynaviLinks">
    <div class="mynaviLinks_flex u-containar">
      <a
        href="https://www.mynavi.jp/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/images/common/logo-mynavi.gif" alt="マイナビ" />
      </a>
      <div class="mynaviLinks_r">
        <dl>
          <dt>求人情報</dt>
          <dd>
            <ul>
              <li v-for="(item, i) in list01" :key="i">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </dd>
        </dl>
        <dl>
          <dt>人材派遣・紹介</dt>
          <dd>
            <ul>
              <li v-for="(item, i) in list02" :key="i">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </dd>
        </dl>
        <dl>
          <dt>情報サービス</dt>
          <dd>
            <ul>
              <li v-for="(item, i) in list03" :key="i">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </dd>
        </dl>
        <dl>
          <dt>進路情報</dt>
          <dd>
            <ul>
              <li>
                <a
                  href="https://shingaku.mynavi.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  高校生の進路情報
                </a>
              </li>
              <li>
                <a
                  href="https://locus.mynavi.jp/mypage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  高校生向け探究学習プログラム Locus
                </a>
              </li>
            </ul>
          </dd>
          <dt>法人向け</dt>
          <dd>
            <ul>
              <li v-for="(item, i) in list04" :key="i">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MynaviLinks',

  setup() {
    const list01 = [
      {
        link: 'https://job.mynavi.jp/',
        label: '学生の就活'
      },
      {
        link: 'https://global.mynavi.jp/',
        label: '留学経験者の就活'
      },
      {
        link: 'https://nurse.mynavi.jp/',
        label: '看護学生向け'
      },
      {
        link: 'https://resident.mynavi.jp/',
        label: '医学生・研修医向け'
      },
      {
        link: 'https://tenshoku.mynavi.jp/',
        label: '転職・求人情報'
      },
      {
        link: 'https://tenshoku.mynavi.jp/global/',
        label: '海外求人'
      },
      {
        link: 'https://scouting.mynavi.jp/',
        label: 'ミドル・ハイクラスの求人'
      },
      {
        link: 'https://baito.mynavi.jp/',
        label: 'アルバイト'
      },
      {
        link: 'https://part.mynavi.jp/',
        label: 'パート'
      },
      {
        link: 'https://mynavi-ms.jp/',
        label: 'ミドル・シニアの求人'
      },
      {
        link: 'https://mpt-shoukai.mynavi.jp/',
        label: '障害者に特化した求人紹介サービス'
      },
      {
        link: 'https://suki-iki.mynavi.jp/',
        label: 'フリーランス・副業向け業務委託案件'
      },
      {
        link: 'https://mynavi-kaigo.jp/',
        label: '福祉・介護の転職／パート'
      }
    ]
    const list02 = [
      {
        link: 'https://staff.mynavi.jp/',
        label: '人材派遣'
      },
      {
        link: 'https://mynavi-creator.jp/',
        label: 'Web・ゲーム業界の転職'
      },
      {
        link: 'https://mynavi-job20s.jp/',
        label: '20代・第二新卒'
      },
      {
        link: 'https://shinsotsu.mynavi-agent.jp/',
        label: '新卒紹介'
      },
      {
        link: 'https://mynavi-agent.jp/',
        label: '転職エージェント'
      },
      {
        link: 'https://executive.mynavi-agent.jp/',
        label: 'エグゼクティブ転職'
      },
      {
        link: 'https://cpa.mynavi.jp/',
        label: '会計士の転職'
      },
      {
        link: 'https://zeirishi.mynavi-agent.jp/',
        label: '税理士の求人・転職'
      },
      {
        link: 'https://komon.suki-iki.mynavi.jp/',
        label: '顧問紹介'
      },
      {
        link: 'https://pharma.mynavi.jp/',
        label: '薬剤師の転職'
      },
      {
        link: 'https://kango.mynavi.jp/',
        label: '看護師の求人'
      },
      {
        link: 'https://co-medical.mynavi.jp/',
        label: 'コメディカル求人'
      },
      {
        link: 'https://doctor.mynavi.jp/',
        label: '医師の転職・求人'
      },
      {
        link: 'https://hoiku.mynavi.jp/',
        label: '保育士の求人'
      },
      {
        link: 'https://mynavi-cr.jp/',
        label: '無期雇用派遣'
      },
      {
        link: 'https://kaigoshoku.mynavi.jp/',
        label: '介護の求人'
      },
      {
        link: 'https://mpro.mynavi.jp/',
        label: '医療業界の経営支援'
      },
      {
        link: 'https://global-saponet.mgl.mynavi.jp/service/all/',
        label: '外国人材の紹介'
      }
    ]
    const list03 = [
      {
        link: 'https://jobsearch.mynavi.jp/',
        label: '求人情報まとめサイト'
      },
      {
        link: 'https://news.mynavi.jp/',
        label: '総合・専門ニュース'
      },
      {
        link: 'https://gakumado.mynavi.jp/teens',
        label: '高校生のチャレンジを応援するサイト'
      },
      {
        link: 'https://teenslab.mynavi.jp/',
        label: 'ティーンマーケティング支援'
      },
      {
        link: 'https://gakumado.mynavi.jp/',
        label: '大学生活情報'
      },
      // {
      //   link: 'https://katekyo.mynavi.jp/',
      //   label: '学生講師の家庭教師'
      // },
      {
        link: 'https://woman.mynavi.jp/',
        label: '働く女性の生活情報'
      },
      {
        link: 'https://book.mynavi.jp/',
        label: '雑誌・書籍・ソフト'
      },
      // {
      //   link: 'https://cue.japan-i.net/',
      //   label: '海外向け（Cue日本）'
      // },
      {
        link: 'https://wedding.mynavi.jp/',
        label: 'ウエディング情報'
      },
      {
        link: 'https://www.sekaken.jp/',
        label: '世界遺産検定'
      },
      // {
      //   link: 'https://travel.mynavi.jp/',
      //   label: '宿泊予約・旅行予約'
      // },
      {
        link: 'https://agri.mynavi.jp/',
        label: '総合農業情報サイト'
      },
      {
        link: 'https://kosodate.mynavi.jp/',
        label: 'マイナビ子育て'
      },
      {
        link: 'https://d2c.mynavi.jp/',
        label: 'ECサイト構築・D2C事業支援'
      },
      {
        link: 'https://furusato.mynavi.jp/',
        label: 'ふるさと納税'
      },
      {
        link: 'https://hakurankai.mynavi.jp/',
        label: 'イベント・展示会'
      },
      {
        link: 'https://mcstudy.mynavi.jp/',
        label: 'My CareerStudy'
      },
      {
        link: 'https://mcid.mynavi.jp/',
        label: 'My CareerID'
      },
      {
        link: 'https://clinic.mynavi.jp/',
        label: '医療施設情報メディア'
      },
      {
        link: 'https://seo.tsukrel.jp/',
        label: 'AIを活用したSEOコンテンツ支援ツール'
      },
      {
        link: 'https://osusume.mynavi.jp/',
        label: 'お買い物サポートメディア'
      },
      {
        link: 'https://mynavi-carehome.jp/',
        label: '高齢者施設検索・介護相談 '
      }
    ]
    const list04 = [
      {
        link: 'https://hrd.mynavi.jp/',
        label: '研修サービス'
      },
      {
        link: 'https://mynavi-bx.jp/',
        label: '業務効率化支援（BPO）'
      },
      {
        link: 'https://msc.mynavi.jp/',
        label: '発送代行'
      },
      {
        link: 'https://kenkokeiei.mynavi.jp/',
        label: '健康経営'
      },
      {
        link: 'https://mynavi-place.jp/ginza/',
        label: '貸会議室・スタジオ'
      },
      {
        link: 'https://biz.mynavi.jp/',
        label: '社宅手配'
      },
      {
        link: 'https://www.trustpocket.mynavi.jp/',
        label: 'リファレンスチェック'
      }
    ]

    return {
      list01,
      list02,
      list03,
      list04
    }
  }
})
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mynaviLinks {
  @include mixins.mediaMax(lg) {
    display: none;
  }

  border-bottom: 1px solid var.$color-border-gray;
  padding-top: 34px;
  padding-bottom: 43px;

  &_flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    img {
      width: 114px;
    }
  }
  &_r {
    width: 875px;
    display: flex;
    justify-content: space-between;
    dt {
      font-size: 13px;
      font-weight: bold;
    }
    dd {
      font-size: 12px;
      + dt {
        margin-top: 75px;
      }
    }
  }
}
</style>
